var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ development: _vm.isDevelopment, displayPreMode: _vm.isDisplayPreMode },attrs:{"id":"app"}},[_c('RouterView',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }